<template>
	<div
		class="user-assign-select-users-list-skeleton"
		:aria-label="$t('spa__general.loading')"
	>
		<div
			v-if="showGroupWrapper"
			class="user-assign-select-users-list-skeleton__group-wrapper"
		>
			<SuiSkeleton width="1.625rem" height="1.75rem" />
			<SuiSkeleton height="2.2475rem" width="40%" />
		</div>
		<div class="user-assign-select-users-list-skeleton__user-wrapper">
			<SuiSkeleton is-circle width="3.5rem" />
			<SuiSkeleton height="1.75rem" width="50%" />
		</div>
		<div class="user-assign-select-users-list-skeleton__user-wrapper">
			<SuiSkeleton is-circle width="3.5rem" />
			<SuiSkeleton height="1.75rem" width="60%" />
		</div>
		<div class="user-assign-select-users-list-skeleton__user-wrapper">
			<SuiSkeleton is-circle width="3.5rem" />
			<SuiSkeleton height="1.75rem" width="40%" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { SuiSkeleton } from '@developers/scoro-ui';

export interface UserAssignSelectListSkeletonProps {
	showGroupWrapper?: boolean;
}

const { showGroupWrapper = false } =
	defineProps<UserAssignSelectListSkeletonProps>();
</script>

<style lang="scss" scoped>
.user-assign-select-users-list-skeleton {
	&__group-wrapper {
		padding: 1.5rem 2rem;
		display: flex;
		align-items: center;
		gap: 1rem;
		border-bottom: 1px solid $neutral-20;
	}

	&__user-wrapper {
		padding: 1rem 2rem 1rem 1rem;
		display: flex;
		align-items: center;
		gap: 1rem;
	}
}
</style>
